import React, { useState } from 'react'
import PackageItem from './PackageItem'
import { useTranslation } from 'react-i18next'

const UpgradablePackages = ({ list, selectItem, selected, handleActivePackage, activePackagePending, idActiveClick, mobileMood, duration }) => {
    const [selectedItem, setSelectedItem] = useState(0)
    const { i18n } = useTranslation()

    
    return (
        <div className={`upgradable-packages ${mobileMood ? 'mobile-device' : ''}`} >
            <div className='package-items-context'  >    {list.map((item, idx) => {
                return (
                    <div
                        key={idx}
                    >
                        <PackageItem
                            {...item}
                            selectItem={() => selectItem(item)}
                            selected={item === selected}
                            handleActivePackage={handleActivePackage}
                            activePackagePending={activePackagePending}
                            idActiveClick={idActiveClick}
                            duration={duration}
                        />
                    </div>
                )
            })}</div>
        </div>

    )
}

export default UpgradablePackages